export default __webpack_public_path__ + "static/media/route.569555c5.png";